import { Observable } from 'rxjs/Observable';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { openIssueTransitionModal } from '../../state/actions/issue-transition/index.tsx';
import { SOFTWARE_BACKLOG_ISSUE_TRANSITION } from './constants.tsx';
import {
	transitionScreenDialogCancel,
	transitionScreenDialogShow,
	transitionScreenDialogSuccess,
} from './events.tsx';
import type { TransitionScreenEvent, TransitionScreenServiceOptions } from './types.tsx';

export function transitionScreenDialogService({
	issueId,
	issueKey,
	transitionId,
	analyticsEvent,
	dispatch,
}: TransitionScreenServiceOptions): Observable<TransitionScreenEvent> {
	return new Observable((subscriber) => {
		const handleDialogSuccess = () => {
			subscriber.next(transitionScreenDialogSuccess());
			subscriber.complete();
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			fireTrackAnalytics(analyticsEvent!, 'issueTransition success', {
				triggerPointKey: SOFTWARE_BACKLOG_ISSUE_TRANSITION,
				isModalOpen: true,
			});
		};
		const handleDialogCancel = () => {
			subscriber.next(transitionScreenDialogCancel());
			subscriber.complete();
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			fireTrackAnalytics(analyticsEvent!, 'issueTransition cancel', {
				triggerPointKey: SOFTWARE_BACKLOG_ISSUE_TRANSITION,
				isModalOpen: true,
			});
		};
		const handleDialogError = (error?: Error | unknown) => {
			subscriber.error(error || new Error('Transition screen failed'));
			subscriber.complete();
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			fireTrackAnalytics(analyticsEvent!, 'issueTransition failed', {
				triggerPointKey: SOFTWARE_BACKLOG_ISSUE_TRANSITION,
				isModalOpen: true,
			});
		};
		const handleDialogShow = () => {
			subscriber.next(transitionScreenDialogShow());
		};

		dispatch(
			openIssueTransitionModal({
				issueId: String(issueId),
				issueKey,
				transitionId: String(transitionId),
				onDialogCancel: handleDialogCancel,
				onDialogError: handleDialogError,
				onDialogSuccess: handleDialogSuccess,
			}),
		);
		handleDialogShow();
	});
}
